@if (saveErrorService.error(); as error) {
	@if (saveErrorService.overlayVisible()) {
		<div class="save-error-backdrop" role="alertdialog" aria-modal="true" aria-labelledby="save-error-title">
			<div class="save-error-card">
				<i class="pi pi-exclamation-triangle save-error-icon"></i>
				<h2 id="save-error-title">Your changes are not saved</h2>
				<p class="save-error-message">{{ error.message }}</p>
				<div class="save-error-actions">
					@if (saveErrorService.canRetry()) {
						<button pButton (click)="saveErrorService.retry()">
							<i class="pi pi-refresh"></i>
							Try saving again
						</button>
					}
					<button pButton severity="secondary" [text]="true" (click)="saveErrorService.dismissOverlay()">
						Keep editing anyway
					</button>
				</div>
				<p class="save-error-hint">
					Nothing is saved until a retry succeeds — we'll warn you again if it keeps failing.
				</p>
			</div>
		</div>
	} @else {
		<button type="button" class="save-error-banner" (click)="saveErrorService.reopenOverlay()">
			<i class="pi pi-exclamation-triangle"></i>
			<span>Not all changes are saved — {{ error.message }}</span>
			<span class="save-error-banner-action">Details</span>
		</button>
	}
}
